<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense color="blue-grey lighten-2")
          v-icon.white--text fa-check-circle
          v-toolbar-title.white--text {{$t('order.completed')}}
    v-layout(row wrap)
      v-flex(xs12 sm6 md4)
        v-text-field.ma-0(
          placeholder="検索: 見積番号/営業担当/業務担当/顧客担当"
          hide-details
          color="info"
          type="text"
          v-model="keyword"
          autocapitalize="off"
          prepend-icon="search"
        )
    v-btn(
      raised
      :disabled="!outputSelectedCount"
      color="primary"
      @click.stop="outputCsv"
    )
      v-icon file_download
      v-badge(color="deep-orange")
        span(slot="badge" v-if="outputSelectedCount > 0") {{outputSelectedCount}}
        span.selected-badge {{$t('list.completed.output_csv')}}

    transition-group(name="flip-list" tag="div" class="layout row wrap")
      div.flex.xs12.sm6.md4.lg3.flip-list-item(v-for="order in filteredList" :key="order.token")
        list-item(
          :token="order.token"
          :requested="false"
          :estimated="false"
          :settled="false"
          :arranged="false"
          :completed="true"
          :search="{ enabled: false, color: 'blue-grey lighten-2', status: $t('order.completed')}"
        )
    div#download-csv-frame(style="display: none;")
</template>

<script>
import rules from '@/common/mixins/rules'
import ListItem from '../Components/ListItem'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ListItem
  },
  data () {
    return {
      keyword: ''
    }
  },
  mixins: [rules],
  created () {
    this.clearList()
    this.$ajax.get(`/order/completed`).then(response => {
      this.setList(response.data.list)
    })
  },
  beforeDestroy () {
    this.clearList()
  },
  computed: {
    ...mapGetters('app/list', [
      'list',
      'outputSelectedCount',
      'selectedTokenList'
    ]),
    filteredList () {
      const search = this.keyword || ''
      const searches = search.split(' ').map(v => new RegExp(v))
      return this.list.filter(order => {
        const searchText = [
          ...new Set([order.id + '', (order.tags || '').split(' ')])
        ]
        return searches.map(v => v.test(searchText)).every(v => v)
      })
    }
  },
  methods: {
    ...mapActions('app/list', ['clearList', 'setList', 'clearSelected']),
    outputCsv () {
      let main = document.getElementById('download-csv-frame')
      while (main.firstChild) {
        main.removeChild(main.firstChild)
      }
      this.$ajax
        .post('order/output_csv', this.selectedTokenList)
        .then(response => {
          response.data.filepaths.forEach(filepath => {
            let encoded = encodeURIComponent(filepath)
            let src =
              process.env.APP_API_URL + `/order/csv_file.csv?q=${encoded}`
            let frame = document.createElement('iframe')
            frame.setAttribute('src', src)
            main.appendChild(frame)
          })
          this.clearSelected()
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.flip-list-item {
  transition: transform 0.5s;
}

.flip-list-enter, .flip-list-leave-to {
  opacity: 0;
}

.flip-list-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/List/Completed/index.vue